import { render, staticRenderFns } from "./SingleBlog.vue?vue&type=template&id=d984e184&scoped=true"
import script from "./SingleBlog.vue?vue&type=script&lang=js"
export * from "./SingleBlog.vue?vue&type=script&lang=js"
import style0 from "./SingleBlog.vue?vue&type=style&index=0&id=d984e184&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d984e184",
  null
  
)

export default component.exports